import ThreeColumnModule from './ThreeColumnModule';

export default ThreeColumnModule;
